module.exports = __webpack_public_path__ + "static/media/032.1b583ac1.jpg";